import { useMutation } from "@tanstack/react-query";
import { useUserManager } from "@/tanstackQuery/queries";
import { updateUser } from "@/api/user";

export const useUpdateUser = () => {
  const userManager = useUserManager();

  return useMutation({
    mutationFn: updateUser,

    onMutate: (payload) => {
      const previous = userManager.get();
      userManager.patch(payload);
      return { previous };
    },

    onSuccess: (data) => {
      userManager.replace(data);
    },

    onError: (_error, _payload, context) => {
      if (context?.previous) {
        userManager.replace(context.previous);
      }
    },
  });
};
